import { jsx as _jsx } from "react/jsx-runtime";
import { PropertyLine } from "./propertyLine";
import { Checkbox } from "../../primitives/checkbox";
/**
 * Wraps a checkbox in a property line
 * @param props - PropertyLineProps and CheckboxProps
 * @returns property-line wrapped checkbox
 */
export const CheckboxPropertyLine = (props) => {
    CheckboxPropertyLine.displayName = "CheckboxPropertyLine";
    return (_jsx(PropertyLine, { ...props, children: _jsx(Checkbox, { ...props }) }));
};
//# sourceMappingURL=checkboxPropertyLine.js.map